export const CHANGE_SIDEBAR_PICKING_COUNTER = "CHANGE_SIDEBAR_PICKING_COUNTER";
export const CHANGE_SIDEBAR_SHIPPING_COUNTER =
  "CHANGE_SIDEBAR_SHIPPING_COUNTER";

export const CHANGE_SIDEBAR_TASKS_COUNTER = "CHANGE_SIDEBAR_TASKS_COUNTER";
